
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointActiveIec as ObiWaypointActiveIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-active-iec.js';
 
 
 

 
 export const ObiWaypointActiveIec = createComponent({
   react: React,
   tagName: 'obi-waypoint-active-iec',
   elementClass: ObiWaypointActiveIecElement,
   events: {
     
   }
  });
 
 